//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_DrawCash, api_SetPromoteCode } from "../../../api";
import { mapMutations } from "vuex";

export default {
	data() {
		return {
			user: {},
			invite_count: 0,
			share_link: '',
			promoteCodeModal: { flag: false, code: '' },
			drawCashModal: { flag: false, name: '', alipay: '', amount: null },
			log_list: { list: [], current: 1, size: 10, total: 0 }
		}
	},
	created() {
		this.setInfo();
	},
	methods: {
		...mapMutations(["setInfo"]),
		pageF(v) {
			this.log_list.current = v;
		},
		copy(text) {
			if (copy(text)) {
				this.$toast.success("复制成功，快去邀请好友吧！");
			} else {
				this.$toast.error("复制失败，请手动选择复制");
			}
		},
		loginbtnClick() {
			this.$bus.$emit('setLoginModal', true);
		},
		submitPromoteCode() {
			if (!/^[a-zA-Z0-9]{4,12}$/.test(this.promoteCodeModal.code)) {
				return this.$toast.error("邀请码格式不正确：须为4-12位英文字母或数字组合")
			}
			api_SetPromoteCode({ val: this.promoteCodeModal.code }).then(res => {
				if (res.data.code === 0) {
					this.$toast.success(res.data.msg);
					this.promoteCodeModal.flag = false;
					this.setInfo();
				} else {
					this.$toast.error(res.data.msg);
				}
			});
		},
		submitDrawCash() {
			if (!/^(?:\w+\.?)*\w+@(?:\w+\.)+\w+|\d{9,11}$/.test(this.drawCashModal.alipay))
				return this.$toast.error("请输入正确的支付宝账号");

			if (this.drawCashModal.amount < 100)
				return this.$toast.error("提现金额不得小于100元");

			if (this.drawCashModal.name.length < 2)
				return this.$toast.error("请输入正确的名字");

			let { amount, name, alipay } = this.drawCashModal;

			api_DrawCash({ amount, name, alipay }).then(res => {
				if (res.data.code === 0) {
					this.$toast.success(res.data.msg);
					this.drawCashModal.flag = false;
					this.setInfo();
				} else {
					this.$toast.error(res.data.msg);
				}
			});
		}
	}
}
